import React, { Component, Fragment } from 'react'
import Cookies from 'js-cookie'
import PropTypes from 'prop-types'

import Button from '../Button/Button'
import Modal from '../../Modal'
import Input from '../Input'
import RDGateway from '../../../gateways/RDGateway'
import { telephoneMask } from '../../../utils/masks'
import { redirectWithCookies } from '../../../utils/Utm'
import ModalTestimonials from '../TestimonialCard/ModalTestimonials'
import InputFloatingLabel from '../InputFloatingLabel'

const FIELDS = ['name', 'email', 'telephone', 'activity', 'users']

const ACTIVITY = {
    industria: 'Indústria',
    distribuicao: 'Distribuição',
    rep: 'Representação Comercial',
    outra: 'Outro'
}

const USERS = {
    um: '1',
    cinco: '2-5',
    vinte: '6-20',
    cinquenta: '21-50',
    cinquentaum: '51 ou mais'
}

class DemoForm extends Component {
    static propTypes = {
        b2b: PropTypes.bool,
        className: PropTypes.string,
        color: PropTypes.string,
        contaAzul: PropTypes.bool,
        partnerId: PropTypes.string,
        modalSmall: PropTypes.bool,
        trialButtonOnly: PropTypes.bool,
        inline: PropTypes.bool,
        newForm: PropTypes.bool,
        buttonVariant: PropTypes.oneOf(['default', 'inverted', 'white', 'inverted-white']),
        textAlign: PropTypes.oneOf(['left', 'center', 'right']),
        ctaButtonText: PropTypes.string,
        demoButtonText: PropTypes.string,
        bottomText: PropTypes.string,
    }

    static defaultProps = {
        b2b: false,
        contaAzul: false,
        trialButtonOnly: false,
        inline: false,
        newForm: true,
        buttonVariant: 'default',
        textAlign: 'center',
        ctaButtonText: 'Faça um teste grátis',
        demoButtonText: 'Peça uma demonstração',
        bottomText: 'Teste grátis por 7 dias | Sem cobrança automática',
    }

    constructor(props) {
        super(props)

        this.rdGateway = new RDGateway()
        this.state = this.getInitialState(props)

        globalThis.optimizeOpenPopup = () => {
            this.setState({ showDemoModal: true });
        }
    }

    getInitialState(props) {
        const initialObject = {
            showDemoModal: false,
            company: '',
            name: '',
            email: '',
            telephone: '',
            activity: '',
            users: '',
            typingTimeout: 0,
            partnerId: props.partnerId,
        }
        FIELDS.forEach(campo => {
            initialObject[`${campo}Error`] = false
            initialObject[`${campo}Typing`] = false
        })
        return initialObject
    }

    setDataByCookie() {
        this.setState({
            partnerId: Cookies.get('leaderPartnerId') || this.state.partnerId || ''
        })
    }

    openDemoModal(e) {
        e.preventDefault()

        this.setState({
            showDemoModal: true
        })
    }

    closeDemoModal() {
        this.setState({
            showDemoModal: false
        })
    }

    handleChange(e) {
        const name = e.target.id
        let value = e.target.value
        let company = this.state.name + ' - ' + this.state.email

        if (name === 'telephone') {
            value = this.telephoneMask(value)
        } else if (name === 'name') {
            company = value + ' - ' + this.state.email
        } else if (name === 'email') {
            value = value.trim()
            company = this.state.name + ' - ' + value
        }

        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }

        this.setState({
            [name]: value,
            company,
            [`${name}Error`]: false,
            [`${name}Typing`]: true,
            typingTimeout: setTimeout(() => {
                if (name === 'email' && this.validateEmail(this.state.email)) {
                }
            }, 3000)
        })
    }

    handlerEnterpriseActivity(tipo) {
        this.setState({ 'activity': tipo })
    }

    getSelectedActivity(selected) {
        return this.state.activity === selected ? 'active' : ''
    }

    handlerUsers(tipo) {
        this.setState({ 'users': tipo })
    }

    getSelectedUsers(selected) {
        return this.state.users === selected ? 'active' : ''
    }

    validation() {
        const newState = {}
        const fieldsToValidate = this.props.inline ? ['name', 'email', 'telephone', 'activity'] : FIELDS

        const regexTelephone = /^\([1-9]{2}\) [2-9][0-9]{3,4}\-[0-9]{4}$/
        fieldsToValidate.forEach(campo => {
            newState[`${campo}Error`] = !this.state[campo]
            switch (campo) {
                case 'email': {
                    newState[`${campo}Error`] = !this.validateEmail(this.state[campo])
                    break
                }
                case 'telephone': {
                    newState[`${campo}Error`] = !regexTelephone.test(this.state[campo])
                    break
                }
            }
        })
        this.setState(newState)
        const lista = Object.values(newState)
        return lista.every(value => (!value))
    }

    validateEmail(email) {
        if (!email) return false
        const trimmedEmail = email.trim()
        const regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return regexEmail.test(trimmedEmail.toLowerCase())
    }

    submitForm(e) {
        e.preventDefault()
        if (this.validation()) {
            const data = {
                conversion_identifier: 'solicite-uma-demonstracao-do-meus-pedidos',
                'cf_tipo_de_conversao': 'Solicitou demonstração',
                company_name: this.state.company,
                name: this.state.name,
                email: this.state.email,
                personal_phone: this.state.telephone,
                'cf_atividade_da_empresa': this.state.activity,
                event_action: 'solicitou_demo',
                event_label: 'forca_de_vendas',
            }

            // Only add users field if not in inline mode
            if (!this.props.inline) {
                data['cf_numero_de_vendedores'] = this.state.users
            }

            if (this.state.partnerId) {
                data.conversion_identifier = 'canais-lp'
                data['cf_codigo_do_parceiro_meus_pedidos'] = this.state.partnerId
            }

            let redirectLink = 'https://mercos.com/tp/solicitou-demo-fv/'
            if (this.state.activity === ACTIVITY.outra) redirectLink = 'https://materiais.mercos.com/tp-smb-solicitou-demo'
            else if (this.state.activity === ACTIVITY.rep) redirectLink = 'https://materiais.mercos.com/tp-reps-solicitou-demo'
            

            this.rdGateway.sendToRDStation(data, redirectLink)

        }
    }

    componentDidMount() {
        this.setDataByCookie()
    }

    getDemoModal() {
        if (this.props.modalSmall) {
            return this.getDemoModalSmall();
        } else
            return (
                <Modal callbackCloseModal={() => this.closeDemoModal()} className="site-simple-modal-testimonials">
                    <div className="modal-header-logo">
                        <div className="logo-mercos-new-home"></div>
                    </div>
                    <div className='container-form-modal'>
                        <h4>Solicite uma demonstração</h4>
                        {this.getForm()}
                    </div>
                    <ModalTestimonials />
                </Modal>
            )
    }

    getDemoModalSmall() {
        return (
            <Modal callbackCloseModal={() => this.closeDemoModal()}>
                <div className="new-form-wrapper">
                    <div className='container-form-modal'>
                        {this.getFormFloatingLabel()}
                    </div>
                </div>
            </Modal>
        )
    }

    telephoneMask(value) {
        let cleanTelephone = value ? value.replace(/\D/g, '') : ''
        const numberLength = cleanTelephone.length

        if (numberLength > 10) {
            cleanTelephone = cleanTelephone.slice(0, 7) + '-' + cleanTelephone.slice(7)
        } else if (numberLength > 6 && numberLength < 11) {
            cleanTelephone = cleanTelephone.slice(0, 6) + '-' + cleanTelephone.slice(6)
        }

        if (numberLength > 2) {
            cleanTelephone = cleanTelephone.slice(0, 2) + ') ' + cleanTelephone.slice(2)
        }

        if (numberLength > 0) {
            cleanTelephone = '(' + cleanTelephone.slice(0)
        }

        return cleanTelephone
    }

    handleActivityDropdownClick = (e) => {
        const dropdown = e.currentTarget.nextElementSibling;
        const button = e.currentTarget;

        dropdown.classList.toggle('show');
        button.classList.toggle('expanded');
    }

    handleActivityOptionClick = (activity) => {
        const button = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown-button');
        const dropdown = document.activeElement.closest('.activity-wrapper').querySelector('.activity-dropdown');

        dropdown.classList.remove('show');
        button.classList.remove('expanded');
        button.classList.add('option-selected');
        button.textContent = activity;

        this.handlerEnterpriseActivity(activity);
    }

    getForm() {
        return (
            <form action='.' method='POST' className='form-rounded-inputs' onSubmit={e => this.submitForm(e)}>
                <input type='hidden' name='company' value={this.state.company} />

                <label htmlFor='name'>Nome</label>
                <Input id='name' value={this.state.name} onChange={e => this.handleChange(e)} error={this.state.nameError} autoFocus />

                <label htmlFor='email'>E-mail</label>
                <Input id='email' value={this.state.email} onChange={e => this.handleChange(e)} error={this.state.emailError} />

                <label htmlFor='telephone'>Telefone</label>
                <Input id='telephone' value={this.state.telephone} onChange={e => this.handleChange(e)} error={this.state.telephoneError} maxLength='15' />

                <label>Qual é a atividade da sua empresa?</label>
                <div className={'group-buttons'}>
                    <Button model='outline' className={this.getSelectedActivity(ACTIVITY.industria)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.industria)}>Indústria</Button>
                    <Button model='outline' className={this.getSelectedActivity(ACTIVITY.distribuicao)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.distribuicao)}>Distribuição</Button>
                    <Button model='outline' className={this.getSelectedActivity(ACTIVITY.rep)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.rep)}>Representante comercial</Button>
                    <Button model='outline' className={this.getSelectedActivity(ACTIVITY.outra)} onClick={() => this.handlerEnterpriseActivity(ACTIVITY.outra)}>Outra</Button>
                    {this.state.activityError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                </div>

                <label>Qual é o número de vendedores da sua empresa?</label>
                <div className={'group-buttons'}>
                    <Button model='outline' className={this.getSelectedUsers(USERS.um)} onClick={() => this.handlerUsers(USERS.um)}>1</Button>
                    <Button model='outline' className={this.getSelectedUsers(USERS.cinco)} onClick={() => this.handlerUsers(USERS.cinco)}>2-5</Button>
                    <Button model='outline' className={this.getSelectedUsers(USERS.vinte)} onClick={() => this.handlerUsers(USERS.vinte)}>6-20</Button>
                    <Button model='outline' className={this.getSelectedUsers(USERS.cinquenta)} onClick={() => this.handlerUsers(USERS.cinquenta)}>21-50</Button>
                    <Button model='outline' className={this.getSelectedUsers(USERS.cinquentaum)} onClick={() => this.handlerUsers(USERS.cinquentaum)}>51 ou mais</Button>
                    {this.state.usersError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                </div>

                <div className='submit-demo-modal'>
                    <Button type='submit' radius={this.props.contaAzul ? 'all-rounded' : 'half-rounded'} className={this.props.contaAzul && 'conta-azul'}>{this.props.children || 'SOLICITAR'}</Button>
                </div>
            </form>
        )
    }

    getFormFloatingLabel() {
        return (
            <Fragment>
                <div className='new-form new-form-floating-inputs' >
                    <p className="new-form-title">Solicite uma demonstração</p>
                    <p className="new-form-subtitle">Um de nossos consultores entrará em contato.</p>
                    <form action='.' method='POST' className='new-form' onSubmit={e => this.submitForm(e)}>
                        <Input type="hidden" name="company" value={this.state.company} />

                        <InputFloatingLabel id="name" value={this.state.name} onChange={e => this.handleChange(e)} error={this.state.nameError} placeholder={'Nome'} />

                        <InputFloatingLabel id="email" value={this.state.email} onChange={e => this.handleChange(e)} error={this.state.emailError} placeholder={'E-mail profissional'} />

                        <InputFloatingLabel id="telephone" value={this.state.telephone} onChange={e => this.handleChange(e)} error={this.state.telephoneError} maxLength="15" placeholder={'Telefone'} />

                        <div className="activity-wrapper">
                            <div className="activity-dropdown-button" onClick={this.handleActivityDropdownClick}>
                                &nbsp;
                            </div>
                            <div className="activity-dropdown">
                                <Button className={this.getSelectedActivity(ACTIVITY.industria)} onClick={() => this.handleActivityOptionClick(ACTIVITY.industria)}><img src="/images/icon-industrias.svg" />Indústrias</Button>
                                <Button className={this.getSelectedActivity(ACTIVITY.distribuicao)} onClick={() => this.handleActivityOptionClick(ACTIVITY.distribuicao)}><img src="/images/icon-distribuidoras.svg" />Distribuidoras</Button>
                                <Button className={this.getSelectedActivity(ACTIVITY.rep)} onClick={() => this.handleActivityOptionClick(ACTIVITY.rep)}><img src="/images/icon-representates.svg" />Representantes</Button>
                                <Button className={this.getSelectedActivity(ACTIVITY.outra)} onClick={() => this.handleActivityOptionClick(ACTIVITY.outra)}><img src="/images/icon-outros.svg" />Outra</Button>
                            </div>
                            <span className='floating-label'>
                                Qual é a atividade da sua empresa?
                            </span>
                            <div className="wrapper-input-vendedores">
                                <p className='label'>Qual é o número de vendedores da sua empresa?</p>
                                <div className={'group-buttons'}>
                                    <Button model='outline' className={this.getSelectedUsers(USERS.um)} onClick={() => this.handlerUsers(USERS.um)}>1</Button>
                                    <Button model='outline' className={this.getSelectedUsers(USERS.cinco)} onClick={() => this.handlerUsers(USERS.cinco)}>2-5</Button>
                                    <Button model='outline' className={this.getSelectedUsers(USERS.vinte)} onClick={() => this.handlerUsers(USERS.vinte)}>6-20</Button>
                                    <Button model='outline' className={this.getSelectedUsers(USERS.cinquenta)} onClick={() => this.handlerUsers(USERS.cinquenta)}>21-50</Button>
                                    <Button model='outline' className={this.getSelectedUsers(USERS.cinquentaum)} onClick={() => this.handlerUsers(USERS.cinquentaum)}>51 ou mais</Button>
                                    {this.state.usersError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                                </div>
                            </div>
                            {this.state.activityError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                        </div>


                        <div className='submit-demo-modal'>
                            <Button type='submit' className='new-submit new-button'>solicitar demonstração</Button>
                        </div>
                    </form>
                </div>
            </Fragment>
        )
    }

    getNewForm() {
        return (
            <Fragment>
                <div className='form-container' >
                    {this.props.title === false ? null : (
                        <div className='form-title'>{this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'}</div>
                    )}
                    <form action='.' method='POST' className='new-form' onSubmit={e => this.submitForm(e)}>
                        <Input type="hidden" name="company" value={this.state.company} />

                        <Input id="name" value={this.state.name} onChange={e => this.handleChange(e)} error={this.state.nameError} placeholder={'Nome'} />

                        <Input id="email" value={this.state.email} onChange={e => this.handleChange(e)} error={this.state.emailError} placeholder={'E-mail profissional'} />

                        <Input id="telephone" value={this.state.telephone} onChange={e => this.handleChange(e)} error={this.state.telephoneError} maxLength="15" placeholder={'Telefone'} />



                        <div className="activity-wrapper">
                            <div className="activity-dropdown-button" onClick={this.handleActivityDropdownClick}>
                                &nbsp;
                            </div>
                            <div className="activity-dropdown">
                                <Button className={this.getSelectedActivity(ACTIVITY.industria)} onClick={() => this.handleActivityOptionClick(ACTIVITY.industria)}><img src="/images/icon-industrias.svg" />Indústrias</Button>
                                <Button className={this.getSelectedActivity(ACTIVITY.distribuicao)} onClick={() => this.handleActivityOptionClick(ACTIVITY.distribuicao)}><img src="/images/icon-distribuidoras.svg" />Distribuidoras</Button>
                                <Button className={this.getSelectedActivity(ACTIVITY.rep)} onClick={() => this.handleActivityOptionClick(ACTIVITY.rep)}><img src="/images/icon-representates.svg" />Representantes</Button>
                                <Button className={this.getSelectedActivity(ACTIVITY.outra)} onClick={() => this.handleActivityOptionClick(ACTIVITY.outra)}><img src="/images/icon-outros.svg" />Outra</Button>

                            </div>
                            <span className='floating-label'>
                                Qual é a atividade da sua empresa?
                            </span>
                            {this.state.activityError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                        </div>


                        <div className='submit-demo-modal'>
                            <Button type='submit' className='new-submit new-button'>solicitar demonstração</Button>
                        </div>
                    </form>
                </div>
            </Fragment>
        )
    }

    getInlineForm() {
        return (
            <Fragment>
                <div className='form-container'>
                    {this.props.title === false ? null : (
                        <div className='form-title'>{this.props.title ? this.props.title : 'Preencha o formulário abaixo e solicite uma demonstração'}</div>
                    )}
                    <form action='.' method='POST' className='new-form' onSubmit={e => this.submitForm(e)}>
                        <Input type="hidden" name="company" value={this.state.company} />

                        <InputFloatingLabel id="name" value={this.state.name} onChange={e => this.handleChange(e)} error={this.state.nameError} placeholder={'Nome'} />

                        <InputFloatingLabel id="email" value={this.state.email} onChange={e => this.handleChange(e)} error={this.state.emailError} placeholder={'Seu e-mail'} />

                        <InputFloatingLabel id="telephone" value={this.state.telephone} onChange={e => this.handleChange(e)} error={this.state.telephoneError} maxLength="15" placeholder={'Telefone'} />

                        <div className="activity-wrapper">
                            <div className="activity-dropdown-button" onClick={this.handleActivityDropdownClick}>
                                &nbsp;
                            </div>
                            <div className="activity-dropdown">
                                <Button className={this.getSelectedActivity(ACTIVITY.industria)} onClick={() => this.handleActivityOptionClick(ACTIVITY.industria)}><img src="/images/icon-industrias.svg" />Indústrias</Button>
                                <Button className={this.getSelectedActivity(ACTIVITY.distribuicao)} onClick={() => this.handleActivityOptionClick(ACTIVITY.distribuicao)}><img src="/images/icon-distribuidoras.svg" />Distribuidoras</Button>
                                <Button className={this.getSelectedActivity(ACTIVITY.rep)} onClick={() => this.handleActivityOptionClick(ACTIVITY.rep)}><img src="/images/icon-representates.svg" />Representantes</Button>
                                <Button className={this.getSelectedActivity(ACTIVITY.outra)} onClick={() => this.handleActivityOptionClick(ACTIVITY.outra)}><img src="/images/icon-outros.svg" />Outra</Button>
                            </div>
                            <span className='floating-label'>
                                Qual é a atividade da sua empresa?
                            </span>
                            {this.state.activityError ? <div style={{ color: 'red' }}>Oops! Você esqueceu de escolher uma opção.</div> : null}
                        </div>

                        <div className='submit-demo-modal'>
                            <Button type='submit' className='new-submit new-button'>solicitar demonstração</Button>
                        </div>
                    </form>
                    
                    <div className="inline-trial-link">
                        <a
                            href='#'
                            onClick={() => redirectWithCookies('https://app.mercos.com/cadastro/')}
                            title='Faça um teste grátis'
                        >
                            <span className="ou-text">ou</span> faça um teste grátis ›
                        </a>
                        <p className="inline-trial-info">Teste grátis por 7 dias | Sem cobrança ao terminar o período grátis</p>
                    </div>
                </div>
            </Fragment>
        )
    }

    getCTA() {
        return (
            <Fragment>
                <div className='cta-text'>
                    <p className='font-light font-12'>explore todos os recursos <span className='cta-text-separator'>| </span>não precisa de cartão de crédito <span className='cta-text-separator'>| </span>simples de usar</p>
                </div>

            </Fragment>


        )
    }

    getModalButton() {
        return (
            <button
                href='.'
                className={this.props.buttonShadow ? 'btn-white-shadow btn-modal ' : `new-button button-secondary btn-modal ${this.props.darkBg ? 'button-secondary' : 'button-secondary-black'} button-cta`}
                onClick={e => this.openDemoModal(e)}
                title='Peça uma demonstração aos nossos especialistas.'
            >
                {this.props.fixedBottomBar ? 'pedir demonstração' : this.props.modalButtonText || 'peça uma demonstração'}
            </button>
        )
    }

    getModalLink() {
        return (
            <div className='or-demo-wrapper'>
                {this.props.showOr && (
                    <span style={{ textDecoration: 'none' }}> ou </span>
                )}
                <a
                    href='.'
                    className={`button-txt btn-modal ${this.props.darkBg ? 'button-txt-white' : ''}`}
                    onClick={e => this.openDemoModal(e)}
                    title='Peça uma demonstração aos nossos especialistas.'
                >

                    {this.props.modalButtonText || 'peça uma demonstração ›'}
                </a>
            </div>

        )
    }


    getTrialButton() {
        return (
            <button
                className={this.props.buttonShadow ? 'btn-green-shadow btn-trial' : `new-button button-primary btn-trial button-cta button-trial ${this.props.darkBg ? 'dark-bg' : ''}`}
                onClick={() => redirectWithCookies('https://app.mercos.com/cadastro/')}
                href='#'
                title='Cadastre-se no Mercos!'
            >
                {this.props.trialAndDemo ? this.props.trialAndDemo : 'teste grátis'}
            </button>
        )
    }
    getTrialAndDemo() {
        return (
            <Fragment>
                <div className={`wrapper-trial-and-demo ${this.props.reverseButtons ? 'reverse-buttons' : ''}`}>
                    {this.getTrialButton()}
                    {this.props.modalLink ? this.getModalLink() : this.getModalButton()}

                </div>
                {this.props.ctaText ? this.getCTA() : ''}
            </Fragment>

        )
    }

    getNewFormButtons() {
        const { buttonVariant, textAlign, ctaButtonText, demoButtonText, bottomText } = this.props;

        const isWhiteVariant = buttonVariant === 'white' || buttonVariant === 'inverted-white';
        const isInverted = buttonVariant === 'inverted' || buttonVariant === 'inverted-white';

        // Determine outline color (white or green)
        const outlineClass = isWhiteVariant ? 'new-form-btn-bordered-white' : 'new-form-btn-bordered-green';

        // Default: Faça=solid, Peça=outline
        // Inverted: Peça=solid, Faça=outline
        const trialButtonClass = isInverted ? `new-form-btn ${outlineClass}` : 'new-form-btn new-form-btn-solid-green';
        const demoButtonClass = isInverted ? 'new-form-btn new-form-btn-solid-green' : `new-form-btn ${outlineClass}`;

        const trialButton = (
            <button
                className={trialButtonClass}
                onClick={() => redirectWithCookies('https://app.mercos.com/cadastro/')}
                title='Cadastre-se no Mercos!'
            >
                {ctaButtonText || 'Faça um teste grátis'}
            </button>
        );

        const demoButton = (
            <button
                className={demoButtonClass}
                onClick={e => this.openDemoModal(e)}
                title='Peça uma demonstração aos nossos especialistas.'
            >
                {demoButtonText || 'Peça uma demonstração'}
            </button>
        );

        return (
            <Fragment>
                <div className={`new-form-buttons-wrapper text-align-${textAlign}`}>
                    <div className="new-form-buttons-container">
                        {isInverted ? (
                            <Fragment>
                                {demoButton}
                                {trialButton}
                            </Fragment>
                        ) : (
                            <Fragment>
                                {trialButton}
                                {demoButton}
                            </Fragment>
                        )}
                    </div>
                    {bottomText && (
                        <p className="new-form-bottom-text">
                            {bottomText.includes('|') ? (
                                <Fragment>
                                    <span className="desktop-text">{bottomText}</span>
                                    <span className="mobile-text">
                                        {bottomText.split('|').map((part, index) => (
                                            <Fragment key={index}>
                                                {part.trim()}
                                                {index < bottomText.split('|').length - 1 && <br />}
                                            </Fragment>
                                        ))}
                                    </span>
                                </Fragment>
                            ) : (
                                bottomText
                            )}
                        </p>
                    )}
                </div>
            </Fragment>
        );
    }

    render() {
        return (
            <Fragment>
                <div className={`new-form-wrapper ${this.props.inline ? 'new-form-wrapper-b2b' : ''} ${this.props.ctaText ? 'same-width-buttons' : ''} ${this.props.darkBg ? 'dark-bg' : ''} ${this.props.fixedBottomBar ? 'demo-fixed-bottom' : ''} ${this.props.inlineBtns ? 'inline' : ''} ${this.props.newForm ? 'new-form-variant' : ''} ${this.props.buttonVariant === 'white' || this.props.buttonVariant === 'inverted-white' ? 'variant-white' : ''} ${this.props.className ? this.props.className : ''}`}>
                    {!this.props.showForm && this.props.newForm ? (
                        this.getNewFormButtons()
                    ) : !this.props.showForm && this.props.trialButtonOnly ? (
                        <button
                            className='btn-green-shadow btn-modal'
                            onClick={e => this.openDemoModal(e)}
                            title='Peça uma demonstração aos nossos especialistas.'
                        >
                            {this.props.modalButtonText || 'quero contratar'}
                        </button>
                    ) : !this.props.showForm ? (
                        this.getTrialAndDemo()
                    ) : null}

                    {this.props.showForm ?
                        (
                            <div div className="show-full-form">
                                {this.props.inline ? this.getInlineForm() : this.getForm()}
                            </div>
                        )
                        : ''}
                    {this.state.showDemoModal && this.getDemoModal()}
                </div>

            </Fragment >
        )
    }
}

export default DemoForm



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/Forms/DemoForm.jsx